export default {
  props: {
    isOa: Boolean,
    showFormBtn: Boolean,
    showMsgBtn: Boolean,
  },
  data () {
    return {
    }
  },
  methods: {
    export (type) {
      this.$emit('export', type)
    },
    close () {
      this.$emit('close')
    },
    exportByOa (type) {
      const { isOa } = this.$props
      this.$emit('export', isOa ? type : 3)
    }
  },
  render (h) {
    const { showFormBtn, showMsgBtn } = this.$props

    const renderBtn = () => {
      return (
        <div class="kye-data-export-footer">
          <kye-button type="text" onClick={() => this.export(1)}>明文导出</kye-button>
          <kye-button type="primary" onClick={() => this.exportByOa(0)}>无需解密导出</kye-button>
          <kye-button onClick={this.close}>取消</kye-button>
        </div>
      )
    }

    const renderFormBtn = () => {
      return (
        <div class="kye-data-export-footer">
          <kye-button type="text" onClick={() => this.exportByOa(0)}>无需解密导出</kye-button>
          <kye-button type="primary" onClick={() => this.export(2)}>提出申请</kye-button>
          <kye-button onClick={this.close}>取消</kye-button>
        </div>
      )
    }

    const renderMsgBtn = () => {
      return (
        <div class="kye-data-export-footer">
          <kye-button type="primary" onClick={() => this.exportByOa(0)}>确定</kye-button>
          <kye-button onClick={this.close}>取消</kye-button>
        </div>
      )
    }

    return showMsgBtn ? renderMsgBtn() : (showFormBtn ? renderFormBtn() : renderBtn())
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-data-export/components/footer.js